import React, { useEffect, useState } from 'react';
import validator from 'validator';
import * as R from 'ramda';
import Button, { ButtonStyle } from '../Button/Button';
import SVGThumbsUp from '../../assets/svg/icons/SVGThumbsUp';
import SVGThumbsDown from '../../assets/svg/icons/SVGThumbsDown';
import SVGCamera from '../../assets/svg/icons/SVGCamera';
import SVGCaretLeft from '../../assets/svg/icons/SVGCaretLeft';
import SVGCloseX from '../../assets/svg/icons/SVGCloseX';
import SVGCopy from '../../assets/svg/icons/SVGCopy';
import SVGDocument from '../../assets/svg/icons/SVGDocument';
import SVGDot from '../../assets/svg/icons/SVGDot';
import SVGError from '../../assets/svg/icons/SVGError';
import SVGFaceScan from '../../assets/svg/icons/SVGFaceScan';
import SVGPerson from '../../assets/svg/icons/SVGPerson';
import SVGInfo from '../../assets/svg/icons/SVGInfo';
import SVGLock from '../../assets/svg/icons/SVGLock';
import SVGMiniQR from '../../assets/svg/icons/SVGMiniQR';
import SVGPhone from '../../assets/svg/icons/SVGPhone';
import SVGScrollArrow from '../../assets/svg/icons/SVGScrollArrow';
import SVGShieldCheck from '../../assets/svg/icons/SVGShieldCheck';
import SVGSolana from '../../assets/svg/icons/SVGSolana';
import Toggle from '../Toggle/Toggle';
import ReactInputVerificationCode from 'react-input-verification-code';
import SVGHeartKeyhole from '../../assets/svg/icons/orange/SVGHeartKeyhole';
import SVGCivicMe from '../../assets/svg/icons/SVGCivicMe';

export default function ThemeSwitchDevPage(): JSX.Element {
  const [showValidationError, setShowValidationError] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const [enabled, setEnabled] = useState<boolean>(false);
  const [token, setToken] = useState<string>('');

  useEffect(() => {
    const emailIsValid = validator.isEmail(email);
    setShowValidationError(!emailIsValid && !R.isEmpty(email));
  }, [email]);

  return (
    <div className="mb-24 pt-2 flex flex-col items-center gap-y-2 iframe-view-container bg-background">
      <div className="flex-shrink-0 flex-grow-0 flex flex-col items-center justify-center mx-6">
        <div className="grid grid-cols-3 gap-1 items-center justify-center">
          <Button style={ButtonStyle.DEFAULT} onClick={() => {}} disabled={false}>
            Normal
          </Button>
          <Button style={ButtonStyle.DEFAULT} onClick={() => {}} disabled>
            Disabled
          </Button>
          <Button style={ButtonStyle.DEFAULT} onClick={() => {}} disabled={false} loading>
            Loading
          </Button>

          <Button style={ButtonStyle.INVERTED} onClick={() => {}} disabled={false}>
            Inverted
          </Button>
          <Button style={ButtonStyle.INVERTED} onClick={() => {}} disabled>
            Disabled
          </Button>
          <Button style={ButtonStyle.INVERTED} onClick={() => {}} disabled={false} loading>
            Loading
          </Button>

          <Button style={ButtonStyle.ROUND_OUTLINE} onClick={() => {}} disabled={false}>
            <SVGThumbsUp />
          </Button>
          <Button style={ButtonStyle.ROUND_OUTLINE} onClick={() => {}} disabled>
            <SVGThumbsDown />
          </Button>
          <Button style={ButtonStyle.BACK} onClick={() => {}} disabled={false}>
            Back
          </Button>
        </div>

        <div className="w-full flex flex-col items-center justify-center mt-4">
          <input
            className={`w-72 rounded-md border-1 ring ring-transparent focus:ring-transparent bg-inputFieldBackground focus:bg-inputFieldBackgroundFocus ${
              showValidationError
                ? 'border-warning focus:border-warning'
                : 'border-inputFieldBorder focus:border-inputFieldBackgroundFocus'
            }`}
            type="text"
            placeholder="Input with validation (email)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <div>
            <>{showValidationError && <span className="textDetail text-warning">Validation Error</span>}</>
            <>{!showValidationError && <div className="my-6" />}</>
          </div>
        </div>
      </div>
      <ul className="mt-1 pl-4">
        <li className="mb-5">
          <h1>H1 Headline</h1>
        </li>
        <li className="mb-5">
          <h2>H2 SubHead</h2>
        </li>
        <li className="mb-5">
          <p>P Paragraph</p>
        </li>
        <li className="textDetail mb-5">
          <span>Detail</span>
        </li>
        <li className="textFooter mb-5">
          <span>Footer</span>
        </li>
        <li className="text-textTertiary mb-5">
          <span>Text Tertiary</span>
        </li>
        <li className="textLink mb-5">
          <a href="www.civic.com" target="_blank" rel="noreferrer">
            Text Link
          </a>
        </li>

        <div className="w-full gap-x-2 flex flex-row items-center">
          <input type="checkbox" className="form-checkbox checkBox" onChange={() => {}} />
          <input type="checkbox" className="form-checkbox checkBox" onChange={() => {}} checked />
          <div className="flex items-center">
            <Toggle enabled={enabled} alwaysShowLabels setEnabled={setEnabled} />
          </div>
        </div>

        <div className="verification-code-input my-2" data-testid="EMAIL_TOKEN_ENTRY_INPUT">
          <ReactInputVerificationCode
            length={5}
            autoFocus
            placeholder=""
            onChange={setToken}
            value={token}
            onCompleted={() => {}}
          />
        </div>
      </ul>
      <div className="w-full">
        <div className="full-width-ruler" />

        <Button style={ButtonStyle.WIDE_SELECTOR} onClick={() => {}} disabled={false}>
          <div className="py-4 px-8 grid grid-cols-5 w-full items-center justify-left">
            <span className="col-span-4 text-left">Selector Button</span>
            <div>
              <span className="float-right">
                <SVGPhone />
              </span>
            </div>
          </div>
        </Button>

        <div className="full-width-ruler" />
      </div>
      <div className="w-full grid grid-flow-row grid-cols-5">
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGThumbsUp />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGThumbsDown />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGCamera />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGShieldCheck />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGCaretLeft />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGInfo />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGSolana />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGCloseX />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGLock />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGCopy />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGMiniQR />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGDocument />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGPhone />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGDot />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGError />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGFaceScan />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGPerson />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGScrollArrow />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGHeartKeyhole />
        </div>
        <div className="w-16 h-16 flex items-center justify-center">
          <SVGCivicMe />
        </div>
      </div>
    </div>
  );
}
